<script setup lang="ts">
import Icon from '../../components/icon/Icon.vue';

export type AppShellSidebarVariant = 'desktop' | 'mobile';

export interface AppShellSidebarFooterProps {
	variant?: AppShellSidebarVariant;
	showAppSwitcher?: boolean;
}

withDefaults(defineProps<AppShellSidebarFooterProps>(), {
	variant: 'desktop',
	showAppSwitcher: false,
});

defineEmits<{
	switchApps: [];
}>();
</script>

<template>
	<div
		:class="[
			'flex w-full flex-col gap-sm',
			variant === 'mobile' ? 'border-t border-border' : '',
		]"
	>
		<button
			v-if="showAppSwitcher"
			type="button"
			:class="
				variant === 'desktop'
					? 'flex w-full items-center gap-3 rounded-md px-3 py-3 transition-colors duration-normal text-white hover:text-gray-300'
					: 'flex w-full items-center justify-center gap-3 rounded-md px-3 py-3 transition-colors duration-normal text-on-surface-variant hover:bg-surface-elevated hover:text-on-surface'
			"
			@click="$emit('switchApps')"
		>
			<Icon
				name="switchApps"
				:size="variant === 'desktop' ? 'sm' : 'md'"
				:class="variant === 'desktop' ? 'text-gray-400' : ''"
			/>
			<span
				:class="
					variant === 'desktop'
						? 'flex-1 text-left text-sm'
						: 'text-left text-sm font-semibold'
				"
			>
				Switch Apps
			</span>
		</button>
	</div>
</template>
